export default {
    routerName: 'タグ管理',
    tag: {
        searchName: '検索条件',
        name: 'タグ名',
        sortOrder: 'ソート',
        status: '状態',
        open: '有効',
        close: '無効',
        createBy: '作成者',
        createTime: '作成日付',
        createStartTime: '作成開始日付',
        createEndTime: '作成終了日付',
    },
    table: {
        id: 'ID',
        name: 'タグ名',
        sortOrder: 'ソート',
        createBy: '作成者',
        createTime: '作成日付',
        status: '状態',
    },
};
